import centerOfMass from '@turf/center-of-mass';
import distance from '@turf/distance';
import booleanPointInPolygon from '@turf/boolean-point-in-polygon';

export function orderPolygonsByDistanceToPoint(polygons, point) {
  return polygons.sort((a, b) => {
    // First check if point is inside polygons
    const pointInA = booleanPointInPolygon(point, a);
    const pointInB = booleanPointInPolygon(point, b);
    // If it is in both or neither, we just move on to center-check
    if ((pointInA && !pointInB) || (!pointInA && pointInB)) {
      return pointInA ? -1 : 1;
    }

    // Then find out which has center closest to point
    const aCenter = centerOfMass(a);
    const bCenter = centerOfMass(b);
    return distance(point, aCenter) - distance(point, bCenter);
  });
}
